import {
	BackendUserStoryTest,
	IUseCaseData,
	IUserStoryTest,
} from 'components/TicketSteps/TestCasesStep/types';

import { ISummary, LoadUseCaseItem } from './types';

export const transformTestsResponseToState = (
	data: Array<BackendUserStoryTest>
): Array<IUserStoryTest> =>
	data.map((item) => ({
		...item,
		testScenarios: item.testScenarios.trim().split('. '),
		testCases: item.testCases
			.map((item) => ({
				...item,
				testSteps: item.testSteps
					.trim()
					.split('. ')
					.filter((test) => isNaN(Number(test))),
			}))
			.sort((a, b) => a.testCaseId.localeCompare(b.testCaseId)),
	}));

export const mergeRelatedUserStoriesInUseCases = (
	data: LoadUseCaseItem[],
	currentTicketSummaries?: ISummary
): IUseCaseData[] =>
	data.map(({ ticketSummaryIds, ...rest }) => ({
		...rest,
		relatedUserStories: currentTicketSummaries?.filter(
			(summary) => ticketSummaryIds?.includes(summary.id as string)
		),
	}));
